"use client";
import { Providers } from "@/redux/provider";
import { useLocale } from "next-intl";
import { useSearchParams } from "next/navigation";
import nookies from "nookies";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import React, { ReactNode, useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ThemeProvider } from "styled-components";
import "../styles/font.css";
import GlobalStyles from "../styles/GlobalStyles";
import { theme } from "../styles/theme";
import { RTLlanguagesLocale } from "../styles/variable";
import ToastProvider from "./ToasterProvider";

const isProd = process.env.NEXT_PUBLIC_NODE_ENV === "production";
interface WithProviderProps {
  children: ReactNode;
  host: string;
}

const ProviderLayout: React.FC<WithProviderProps> = ({ children, host }) => {
  const locale = useLocale();
  const searchParams = useSearchParams();
  const indicative_id = searchParams.get("indicative_id");
  const cookies = nookies.get({});
  const { indicative_unique_id } = cookies;
  const eventId = indicative_id || indicative_unique_id;

  useEffect(() => {
    if(isProd){
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY || "", {
      api_host: "https://us.i.posthog.com",
      person_profiles: "always",
      autocapture: false,
      loaded: (posthog) => {
        if (!isProd) posthog.debug();
      },
    });
    }
    if (eventId) {
      posthog.identify(eventId);
      posthog.alias(eventId);
    }
    const renderHack = () => {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        window.history.go(0);
      };
    };
    renderHack();
    window.addEventListener("popstate", renderHack);
    return () => {
      window.removeEventListener("popstate", renderHack);
    };
  }, []);

  return (
    <PHProvider client={posthog}>
      <ThemeProvider
        theme={{ ...theme, isRTL: RTLlanguagesLocale.includes(locale) }}
      >
        <ToastProvider>
          <Providers host={host}>
            <GlobalStyles />
            {children}
          </Providers>
        </ToastProvider>
      </ThemeProvider>
    </PHProvider>
  );
};

export default ProviderLayout;
